import { ReactNode } from "react";

import { Box, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";

interface ICampaignAlertProperties {
  message: ReactNode | string;
  severity?: "error" | "info" | "success" | "warning";
  title: string;
}

export default function CampaignAlert({ message, severity = "info", title }: ICampaignAlertProperties) {
  return (
    <Alert
      severity={severity}
      sx={{
        alignItems: "center",
        display: "flex",
      }}
      title="Awaiting Campaign Metrics"
      variant="filled"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          width: "100%",
        }}
      >
        <Typography fontWeight={600} variant="body1">
          {title}
        </Typography>
        <Typography fontWeight={500} variant="body2">
          {message}
        </Typography>
      </Box>
    </Alert>
  );
}
